<template>
	<div id="login">            
        <hr class="path ml-5 hide-on-mobile">
        <ValidationObserver tag="form" v-slot="{ invalid }" onsubmit="return false;" class="mx-auto w-m-80 w-30">
        <img src="img/group-2@3x.png" alt="Bisa Cek" class="group-2 mx-auto d-block mb-5 img-fluid">
            <p class="text-center" v-show="message">{{ message }}</p>

            <ValidationProvider name="password" rules="required">
            <div class="form-group" slot-scope="{ errors }">
                <label class="form-label">Kata sandi baru</label>
                <div class="input-group" id="show_hide_password" :class="{ 'error': errors[0] }">
                    <input type="password" v-model="password" class="form-control append-button" placeholder="Masukkan kata sandi baru">
                    <div class="input-group-append">
                        <span class="input-group-text">
                            <i class="fa fa-eye-slash" aria-hidden="true"></i>
                        </span>
                    </div>
                </div>
                <div class="error-alert">{{ errors[0] }}</div>
            </div>
        	</ValidationProvider>

        	<ValidationProvider name="password_confirm" rules="required|confirmed:password">
            <div class="form-group" slot-scope="{ errors }">
                <label class="form-label">Ulangi kata sandi</label>
                <div class="input-group" id="show_hide_password_confirm" :class="{ 'error': errors[0] }">
                    <input type="password" v-model="password_confirm" class="form-control append-button" placeholder="Ulangi kata sandi baru">
                    <div class="input-group-append">
                        <span class="input-group-text">
                            <i class="fa fa-eye-slash" aria-hidden="true"></i>
                        </span>
                    </div>
                </div>
                <div class="error-alert">{{ errors[0] }}</div>
            </div>
        	</ValidationProvider>

            <button :disabled="invalid" @click="reset" type="submit" class="btn btn-primary w-full pd-10-20">Reset Kata Sandi</button>
        </ValidationObserver>           
    </div>
</template>

<script>
import $ from 'jquery'

export default {
	name: 'ResetPassword',
	data() {
		return {
			email: this.$route.query.email,
			token: this.$route.query.token,
			password: null,
			password_confirm: null,
			message: null,
			authFalse: false
		}
	},
	methods: {
		reset() {
			let _ = this
            _.axios.post('/auth/reset_password', { email: _.email, password: _.password, token: _.token })
                .then(resp=>{
                    _.message = resp.data.data.message
                    _.$router.push('/success-reset-password')
                })
                .catch(err=>{
                    _.message = err.response.data.error.message
                    _.authFalse = true
                })
		}
	},
	mounted() {
		$("#show_hide_password span").on('click', function(event) {
	        event.preventDefault();
	        if($('#show_hide_password input').attr("type") == "text"){
	            $('#show_hide_password input').attr('type', 'password');
	            $('#show_hide_password i').addClass( "fa-eye-slash" );
	            $('#show_hide_password i').removeClass( "fa-eye" );
	        }else if($('#show_hide_password input').attr("type") == "password"){
	            $('#show_hide_password input').attr('type', 'text');
	            $('#show_hide_password i').removeClass( "fa-eye-slash" );
	            $('#show_hide_password i').addClass( "fa-eye" );
	        }
	    });

	    $("#show_hide_password_confirm span").on('click', function(event) {
	        event.preventDefault();
	        if($('#show_hide_password_confirm input').attr("type") == "text"){
	            $('#show_hide_password_confirm input').attr('type', 'password');
	            $('#show_hide_password_confirm i').addClass( "fa-eye-slash" );
	            $('#show_hide_password_confirm i').removeClass( "fa-eye" );
	        }else if($('#show_hide_password_confirm input').attr("type") == "password"){
	            $('#show_hide_password_confirm input').attr('type', 'text');
	            $('#show_hide_password_confirm i').removeClass( "fa-eye-slash" );
	            $('#show_hide_password_confirm i').addClass( "fa-eye" );
	        }
	    });
	}
}
</script>